import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@chakra-ui/react';
import { fieldErrorColor } from '@client/theme';
export const FieldError = ({ fontSize = 15, children, ...rest }) => (_jsx(Text, { fontSize: fontSize, fontWeight: 500, color: fieldErrorColor, ...rest, children: children }));
